import http from '@/http';

const endpoint = process.env.VUE_APP_OCR_ENDPOINT;
const login = process.env.VUE_APP_OCR_LOGIN;
const email = process.env.VUE_APP_OCR_EMAIL;
const password = process.env.VUE_APP_OCR_PASSWORD.replace(/__DOLLAR__/g, '$');
const analyze = process.env.VUE_APP_OCR_ANALYZE;

// Função principal que lida com a imagem OCR
export async function handleImagemOcr(imagem) {
    let resposta = "";
    // Realiza o login OCR para obter o token e, em seguida, envia a imagem com o token
    await efetuarLoginOcr().then(token => {
        resposta = enviaImagemOcr(token, imagem);
    });
    return resposta;
}

// Função para efetuar o login OCR e obter o token
function efetuarLoginOcr() {
    return new Promise((resolve, reject) => {
        http
            .post(endpoint + login, {
                email: email,
                password: password,
            })
            .then(response => {
                resolve(response.data.access_token);
            })
            .catch(error => {
                reject(error);
            });

    });
}

// Função para enviar a imagem OCR com o token
async function enviaImagemOcr(token, base64) {
    try {
        const blob = await fetch(base64).then(res => res.blob());

        const formData = new FormData();
        formData.append('id', '3254');
        formData.append('image', new File([blob], 'filename.png'));

        const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject('Tempo de analise excedido (10s). Por favor, preencha manualmente.'), 10000)
        );

        const fetchPromise = fetch(endpoint + analyze, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
            },
        });

        const response = await Promise.race([fetchPromise, timeoutPromise]);

        if (response.ok) {
            const ocrData = await response.json();

            return ocrData;
        } else {
            return { error: true };
        }
    } catch (error) {
        throw error;
    }

}

